module.exports = function () {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var html = "\n\t<div class=\"saito-input\">\n\t\t<div id=\"text-input\" class=\"text-input hide-scrollbar\" type=\"text\" value=\"\" autocomplete=\"off\" placeholder=\"".concat(placeholder, "\" contenteditable=\"true\"></div>\n\t\t<i class=\"saito-emoji fa-regular fa-face-smile\"></i>\n\t</div>\n\t");
  return html;
};